export const COMPANY = {
    name: "Pacific Expressway",
    established: 2002,
    domain: "https://www.pacificexpressway.com",
    address: {
        street: "18726 S. Laurel Park Rd.",
        city: "Rancho Dominguez, CA 90220",
    },
    phone: "(310) 363-0713",
    phoneHref: "tel:+13103630713",
    email: "Dispatch@pacificexpressway.com",
    emailHref: "mailto:Dispatch@pacificexpressway.com",
    hours: [
        { days: "Monday – Friday", time: "Open 24 Hours" },
        { days: "Saturday", time: "7:00 AM – 4:00 PM" },
    ],
    mapEmbed:
        "https://maps.google.com/maps?q=18726%20S%20Laurel%20Park%20Rd%2C%20Rancho%20Dominguez%2C%20CA%2090220&t=&z=13&ie=UTF8&iwloc=&output=embed",
};

export const IMAGES = {
    hero: "/images/hero.webp",
    portTerminal: "/images/portTerminal.webp",
    trucksHighway: "/images/trucksHighway.webp",
    fleetTruck: "/images/fleetTruck.webp",
    forklift: "/images/forklift.webp",
    containerStacks: "/images/containerStacks.webp",
    containers: "/images/containers.webp",
    semiHighway: "/images/semiHighway.webp",
    warehouse: "/images/warehouse.webp",
    portCrane: "/images/portCrane.webp",
    containersAerial: "/images/containersAerial.webp",
    warehouseForklift: "/images/warehouseForklift.webp",
    aboutTrucks: "/images/aboutTrucks.webp",
    portStacks: "/images/portStacks.webp",
};

export const CAPACITY_STATS = [
    { value: "100+", label: "Trucks" },
    { value: "500+", label: "Chassis" },
    { value: "Dual-Yard", label: "Operation" },
    { value: "900+", label: "Containers / Week" },
];

export const VOLUME_STATS = [
    { value: "100+", label: "Class 8 Trucks" },
    { value: "500+", label: "Chassis Fleet" },
    { value: "2", label: "Operating Yards" },
    { value: "90K", label: "Top Pick Handler" },
    { value: "900+", label: "Containers / Week" },
    { value: "OW", label: "Corridor Capable" },
];

export const SERVICES = [
    {
        id: "port-drayage",
        title: "Port Drayage",
        description:
            "High-volume container transportation serving the Ports of Los Angeles and Long Beach, backed by our own trucks and chassis.",
        image: IMAGES.portTerminal,
        alt: "Shipping containers stacked at a Port of Los Angeles / Long Beach container terminal",
    },
    {
        id: "transloading",
        title: "Transloading",
        description:
            "Efficient container unloading, freight transfer and preparation for onward transportation.",
        image: IMAGES.forklift,
        alt: "Forklift transferring palletized freight during a transload operation",
    },
    {
        id: "cross-docking",
        title: "Cross-Docking",
        description:
            "Rapid freight transfer and consolidation designed to reduce storage time and keep shipments moving.",
        image: IMAGES.warehouse,
        alt: "Warehouse interior with pallet racking and staged freight",
    },
    {
        id: "overweight-oog",
        title: "Overweight & OOG",
        description:
            "Solutions for overweight, heavy, oversized and difficult freight, including overweight corridor operations.",
        image: IMAGES.containerStacks,
        alt: "Heavy shipping containers staged for overweight freight handling",
    },
    {
        id: "warehousing",
        title: "Warehousing & Storage",
        description:
            "Short- and long-term storage, inventory control, pick-and-pack fulfillment, kitting and rework.",
        image: IMAGES.warehouseForklift,
        alt: "Forklift moving pallets inside a Pacific Expressway warehouse",
    },
    {
        id: "dedicated",
        title: "Dedicated Transportation",
        description:
            "Dedicated fleet capacity for customers requiring consistent, reliable transportation support.",
        image: IMAGES.trucksHighway,
        alt: "Class 8 trucks running dedicated transportation routes",
    },
];

export const CAPABILITIES = [
    "Hazmat",
    "Flatbed / Step Deck",
    "Gensets",
    "Block & Bracing",
    "Inventory Control",
    "Pick & Pack",
    "Kitting",
    "Weight Reduction / Rework",
    "Air / Rail Support",
    "Container Flipping",
    "Top Handler Operations",
];

export const MARQUEE_ITEMS = [
    "Port Drayage",
    "Transloading",
    "Cross-Docking",
    "Overweight & OOG",
    "Warehousing & Storage",
    "Dedicated Transportation",
    "Final Mile",
    "OTR Transportation",
    "Air & Rail Support",
];

export const PROBLEMS = [
    "Stuck containers sitting on demurrage",
    "Chassis shortages at the worst possible time",
    "Overweight freight nobody wants to touch",
    "Slow transload turns tying up your inventory",
    "Unreliable carrier capacity when volumes spike",
    "Port congestion throwing off your delivery windows",
];

export const SERVICE_OPTIONS = [
    "Port Drayage",
    "Transloading",
    "Cross-Docking",
    "Overweight / OOG",
    "Warehousing / Storage",
    "Dedicated Transportation",
    "Final Mile",
    "OTR",
    "Other",
];
